var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["category/templates/category-product-count.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n";
output += "\n";
output += "\n";
output += "\n";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"shouldDisplayResultsOptions")) {
output += "<div class=\"c-results-count dom-results-count\" data-qa-search-results-count>\n\t    ";
output += runtime.suppressValue((lineno = 8, colno = 7, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["search_results-count-label",runtime.makeKeywordArgs({"params": [env.getFilter("default").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"products")),"totalRecordCount"),"0")]})])), env.opts.autoescape);
output += "\n\t</div>\n";
;
}
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["category/templates/category-product-count.j2"] , dependencies)